import { render, staticRenderFns } from "./AlbumManagement.vue?vue&type=template&id=96380694&scoped=true"
import script from "./AlbumManagement.vue?vue&type=script&lang=ts"
export * from "./AlbumManagement.vue?vue&type=script&lang=ts"
import style0 from "./AlbumManagement.vue?vue&type=style&index=0&id=96380694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96380694",
  null
  
)

export default component.exports